import { memo } from "react";

import { translate } from "app/filters/i18nFilter";
import Duration from "app/pages/activation/components/Shared/Duration/Duration";
import { textKeys } from "app/pages/activation/components/Widget/texts";
import * as SC from "app/pages/activation/modules/Project/styles";

import { generateAutomationName } from "../../../helpers/generateAutomationName";

interface HeaderSchema {
    formattedDuration: string;
    isWidgetHover?: boolean;
    isTitleLink?: boolean;
    onClick?: () => void;
}

export const Header = memo(({ formattedDuration, isWidgetHover, isTitleLink, onClick }: HeaderSchema) => (
    <SC.WidgetHeader data-automation={generateAutomationName("widget", ["header", "container"])}>
        <SC.WidgetTitle
            data-automation={generateAutomationName("widget", ["header", "title"])}
            isWidgetHover={isWidgetHover}
            isTitleLink={isTitleLink}
            onClick={onClick}
        >
            {translate(textKeys.bodyHeader)}
        </SC.WidgetTitle>

        <Duration duration={formattedDuration} />
    </SC.WidgetHeader>
));

Header.displayName = "Header";
